import React from 'react';

import { MyFundsRequests } from 'features/funds-request';

export const MerchantArchiveFundsRequests: React.FC = () => <MyFundsRequests />;
